import { TScenarioFormState } from "../../models";
import { ScenarioCard } from "../scenario-card";
import { GridContainer } from "./styles";

interface Participation {
  ativo: boolean;
  reu: boolean;
  citado: boolean;
}

interface IScenarioCardsDisplayProps {
  scenariosForm: TScenarioFormState[];
  onToggleEnabled: (id: number, scenarioId: number) => void;
  onToggleParticipation: (
    id: number,
    field: keyof Participation,
    scenarioId: number
  ) => void;
  scenarioId: number;
  readOnly?: boolean;
}

export const ScenarioCardsDisplay: React.FC<IScenarioCardsDisplayProps> = ({
  scenariosForm,
  onToggleEnabled,
  onToggleParticipation,
  scenarioId,
  readOnly = false,
}) => {
  // Função para dividir os cenários em linhas de 2 elementos
  const getRows = (scenarios: TScenarioFormState[]) => {
    const rows: TScenarioFormState[][] = [];
    for (let i = 0; i < scenarios.length; i += 2) {
      rows.push(scenarios.slice(i, i + 2));
    }
    return rows;
  };

  const rows = getRows(scenariosForm);

  return (
    <GridContainer>
      {rows.map((row, rowIndex) => (
        <div className="grid-row" key={`row-${rowIndex}`}>
          {row.map((scenario) => (
            <ScenarioCard
              key={scenario.id}
              id={scenario.id}
              label={scenario.label}
              isEnabled={scenario.isEnabled}
              onToggleEnabled={onToggleEnabled}
              participation={scenario.participation}
              onToggleParticipation={onToggleParticipation}
              readOnly={readOnly}
              scenarioId={scenarioId}
            />
          ))}
        </div>
      ))}
    </GridContainer>
  );
};
